import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import {
  FDBodyText,
  FDBox,
  FDHeadlineText,
  FDLozenge,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { clientPaths } from 'Consts/Strings';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { dashboardUri } from 'Consts/clientUris';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import { dataAttrs } from 'Helpers/Testing';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';

const ProposalExpirationLayout = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const messagesRel = resource
    .withRelationship(fr.relationships.messagesPage.name,
      (rel) => rel,
      () => null);

  return (
    <LottieLoadingLayout>
      <FadeInBox>
        <FDBox padding={isMobile ? 4 : 8}>
          <FDStack direction={'column'} spacing={7} alignItems={'center'} padding={1}>
            <FDStack direction={'column'} spacing={3} alignItems={'center'}>
              <FDStack direction={'column'} spacing={1} alignItems={'center'} paddingY={1} paddingX={8}>
                <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
                <FDLozenge
                  color={'warning'}
                  label={resource.attr('expirationDate')}
                  size={'lg'}
                  {...dataAttrs('expiration-lozenge')}
                />
              </FDStack>
              <FDStack direction={'column'} spacing={4}>
                <FDHeadlineText size={'lg'} value={resource.attr('title')} align={'center'} />
                <FDStack direction={'column'} spacing={3}>
                  {resource.attr('description').map((text) => {
                    return <FDBodyText size={'lg'} value={text} align={'center'} />;
                  })}
                </FDStack>
              </FDStack>
            </FDStack>
            <FDStack direction={'row'} spacing={3}>
              <FDSecondaryActionButton
                {...dataAttrs('proposal-expiration-dashboard-button')}
                href={dashboardUri}
                label={'Dashboard'}
              />
              {messagesRel
                ? <FDPrimaryActionButton
                  {...dataAttrs('proposal-expiration-messages-page-button')}
                  href={buildPageLink(messagesRel.link('related'), clientPaths.messagesPage, { loadCompose: true })}
                  label={messagesRel.meta('prompt')}
                />
                : null }
            </FDStack>
          </FDStack>
        </FDBox>
      </FadeInBox>
    </LottieLoadingLayout>
  );
};

ProposalExpirationLayout.defaultProps = {
};

ProposalExpirationLayout.propTypes = {
};

export default ProposalExpirationLayout;
